import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
// import { AxiosError } from "axios";
import { CommonResponse, ApiResponseType } from "types/types";
import { notifyError } from "pages/Errors/Error";
// import { ApiResponseType } from "types/types";
import { store } from "store/store";
import { dispatchClearUser } from "store/dispatch/user.dispatch";
import { navigate } from "navigation/navigate"; // Adjust path

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  formikSetErrors?: Function;
  formikSetSubmitting?: Function;
  hideError?: boolean;
}

export const baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use(
  (config) => {
    // ** Get token from localStorage
    const accessToken = store.getState().user.token;
    // ** If token is present add it to request's Authorization Header
    if (accessToken && config.headers) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => {
    if (response && response.data.success) {
      return response.data;
    } else {
      if (
        response.config &&
        (response.config as CustomAxiosRequestConfig).formikSetErrors
      ) {
        const formikSetErrors = (response.config as CustomAxiosRequestConfig)
          .formikSetErrors;
        if (formikSetErrors) {
          formikSetErrors(response.data.message);
        }
      }
      if (
        response.config &&
        (response.config as CustomAxiosRequestConfig).formikSetSubmitting
      ) {
        const formikSetSubmitting = (
          response.config as CustomAxiosRequestConfig
        ).formikSetSubmitting;

        if (formikSetSubmitting) {
          formikSetSubmitting(false);
        }
      }
      if (
        response.config &&
        (response.config as CustomAxiosRequestConfig).hideError
      ) {
        const hideError = (response.config as CustomAxiosRequestConfig)
          .hideError;
        if (typeof response.data.message === "string" && !hideError) {
          notifyError(response.data.message);
        }
      } else {
        if (typeof response.data.message === "string") {
          notifyError(response.data.message);
        }

        // if (!response.config.url?.includes("check-login")) {
        //   dispatchClearUser();
        //   localStorage.removeItem("token");
        //   localStorage.removeItem("userId");
        //   navigate("/login");
        // }
        // return Promise.reject(new Error("An unexpected error occurred"));
      }
      // return Promise.reject(new Error("An unexpected error occurred"));
    }
  },
  (error: AxiosError) => {
    const { response } = error;

    if (response) {
      if ((response.data as ApiResponseType).message) {
        notifyError(String((response.data as ApiResponseType).message));
      }

      if (response.status === 401) {
        dispatchClearUser();
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        navigate("/login");
      }
    }

    // return Promise.reject(error);
  }
);

export const axiosPost = async (
  url: string,
  data: any = {},
  params: any = {},
  formikSetErrors?: Function | null,
  formikSetSubmitting?: Function
): Promise<void | AxiosResponse<CommonResponse>> => {
  return axios
    .post(baseURL + url, data, {
      params,
      formikSetErrors,
      formikSetSubmitting,
    } as CustomAxiosRequestConfig)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (formikSetSubmitting) {
        formikSetSubmitting(false);
      }
      if (formikSetErrors && error.response?.data?.errors) {
        formikSetErrors(error.response.data.errors);
      }

      // ✅ Rethrow or return null so calling code knows something failed
      throw error;
    });
};

export const axiosGet = async (url: string, params: any = {}) => {
  return axios
    .get(baseURL + url, { params })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error.response;
    });
};

export const axiosPut = async (
  url: string,
  data: any = {},
  params: any = {},
  formikSetErrors?: Function,
  formikSetSubmitting?: Function
): Promise<void | AxiosResponse<CommonResponse>> => {
  return axios
    .put(baseURL + url, data, {
      params,
      formikSetErrors,
      formikSetSubmitting,
    } as CustomAxiosRequestConfig)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (formikSetSubmitting) {
        formikSetSubmitting(false);
      }
    });
};

export const axiosPatch = async (
  url: string,
  data: any = {},
  params: any = {},
  formikSetErrors?: Function,
  formikSetSubmitting?: Function
): Promise<void | AxiosResponse<CommonResponse>> => {
  return axios
    .patch(baseURL + url, data, {
      params,
      formikSetErrors,
      formikSetSubmitting,
    } as CustomAxiosRequestConfig)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (formikSetSubmitting) {
        formikSetSubmitting(false);
      }
    });
};

export const axiosDelete = async (
  url: string,
  data: any = {},
  params: any = {},
  formikSetErrors?: Function,
  formikSetSubmitting?: Function,
  hideError: boolean = false
): Promise<void | AxiosResponse<CommonResponse>> => {
  return axios
    .delete(baseURL + url, {
      params,
      data,
      formikSetErrors,
      formikSetSubmitting,
      hideError,
    } as CustomAxiosRequestConfig)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (formikSetSubmitting) {
        formikSetSubmitting(false);
      }
    });
};

export default axios;
